/**
 * Nhãn gói hiển thị — mã gói ("CDB08", "pf_modern") → tên người đọc.
 *
 * Kiểm thử toàn vai 16/09/2026 (B6): `productLabel()` (orders/statusMap) và
 * `productName()` (products/constants) chỉ tra bảng tĩnh 3 dòng cũ, nên gói
 * Gạo Nâu Chụp Ảnh / Travel — 225 trên 246 gói, bán từ QĐ 0088 — hiện mã thô
 * trên danh sách đơn, lịch chụp, bảng điều phối, biểu đồ doanh thu…
 *
 * `ProductLabelProvider` (gắn trong AppShell, vùng đã đăng nhập) phát hàm tra
 * theo danh mục máy chủ. Ngoài provider — trang công khai, bài kiểm dựng lẻ một
 * màn — hàm mặc định là `productLabel` tĩnh, đúng hành vi cũ. Tách khỏi file
 * provider để React Fast Refresh không bỏ qua file (xem ticketContextValue.ts).
 */
import { createContext, useContext } from "react";
import { productLabel } from "@/features/orders/statusMap";

/** Cùng hợp đồng `productLabel`: mặc định tên rút gọn, `{ full: true }` tên đầy đủ, mã lạ trả nguyên văn. */
export type ProductLabelFn = (code: string | null | undefined, opts?: { full?: boolean }) => string;

export const ProductLabelContext = createContext<ProductLabelFn>(productLabel);

export function useProductLabel(): ProductLabelFn {
  return useContext(ProductLabelContext);
}
